import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "v2-product-card" */ './ProductV2'));


